var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[(!_vm.mobile)?_c('Desktop',{attrs:{"menu":_vm.menu}}):_c('Mobile',{attrs:{"menu":_vm.menu}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }